// extracted by mini-css-extract-plugin
export var sbShowMain = "cookies-module--sb-show-main--2pfKq";
export var cookieNotice = "cookies-module--cookieNotice--2y86D";
export var cookieButton = "cookies-module--cookieButton--1SPBN";